<template>
  <div
    id="echartLine"
    class="chart-box"
    style="width:100%;height:100%;"
  />
</template>

<script>
import echarts from 'echarts'
export default {
  data() {
    return {
      chart: null,
      graphData: {
        nodes: [
          { y: 300, x: 130, id: 'Brunei', name: 'Brunei', symbolSize: '30', color: '#a00', countryCode: 'DM_BRU_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 160, x: 70, id: 'Cambodia', name: 'Cambodia', symbolSize: '60', color: '#00a', countryCode: 'DM_KHM_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 190, x: 10, id: 'Indonesia', name: 'Indonesia', symbolSize: '50', color: '#00a', countryCode: 'DM_IDN_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 270, x: 70, id: 'Lao', name: 'Lao', symbolSize: '40', color: '#0a0', countryCode: 'DM_LA_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 220, x: 30, id: 'Malaysia', name: 'Malaysia', symbolSize: '40', color: '#0a0', countryCode: 'DM_MAL_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 90, x: 70, id: 'Myanmar', name: 'Myanmar', symbolSize: '40', color: '#0a0', countryCode: 'DM_MMR_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 240, x: 160, id: 'Phillipine', name: 'Phillipine', symbolSize: '40', color: '#0a0', countryCode: 'DM_PHL_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 300, x: 0, id: 'Singapore', name: 'Singapore', symbolSize: '60', color: '#0a0', countryCode: 'DM_SG_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 130, x: 30, id: 'Thailand', name: 'Thailand', symbolSize: '40', color: '#0a0', countryCode: 'DM_TH_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 130, x: 140, id: 'Vietnam', name: 'Vietnam', symbolSize: '40', color: '#0a0', countryCode: 'DM_VNM_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] },
          { y: 60, x: 120, id: 'China', name: 'China', symbolSize: '80', color: '#0a0', countryCode: 'DM_CHN_MAIN', data: [{ label: 'GDP(2019年)', value: '11537160.22百万美元(同比6.11%)' }, { label: 'CPI(2019年)', value: '125.08(同比2.90%)' }, { label: '总人口(2019年)', value: '139771.50万人(同比0.36%)' }, { label: '失业率(2019年)', value: '4.32%(同比1.03%)' }, { label: '出口(2019年)', value: '26433.77亿美元(同比-0.29%)' }, { label: '进口(2019年)', value: '24792.55亿美元(同比-0.27%)' }] }],
        edges: [
          { source: 'China', attributes: {}, target: 'Vietnam', size: 1 },
          { source: 'China', attributes: {}, target: 'Myanmar', size: 1 },
          { source: 'China', attributes: {}, target: 'Lao', size: 1 },
          { source: 'China', attributes: {}, target: 'Cambodia', size: 1 },
          { source: 'Vietnam', attributes: {}, target: 'Phillipine', size: 1 },
          { source: 'Vietnam', attributes: {}, target: 'Lao', size: 1 },
          { source: 'Cambodia', attributes: {}, target: 'Lao', size: 1 },
          { source: 'Cambodia', attributes: {}, target: 'Thailand', size: 1 },
          { source: 'Cambodia', attributes: {}, target: 'Malaysia', size: 1 },
          { source: 'Singapore', attributes: {}, target: 'Malaysia', size: 1 },
          { source: 'Singapore', attributes: {}, target: 'Indonesia', size: 1 },
          { source: 'Brunei', attributes: {}, target: 'Lao', size: 1 }]
      },
      chartData: [],
      chartLink: []
    }
  },
  mounted() {
    this.initEchart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initEchart() {
      const imageUrl = '/static/images/country/'
      const that = this
      this.chart = echarts.init(document.getElementById('echartLine'))
      const nodes = that.graphData.nodes
      const picList = []
      for (var i = 0; i < nodes.length; i++) {
        const p = that.getImgData(imageUrl + nodes[i].name + '.png')
        picList.push(p)
      }
      Promise.all(picList).then(function(images) {
        for (var i = 0; i < images.length; i++) {
          var img = 'image://' + images[i]
          nodes[i].symbol = img
        }
        const option = {
          tooltip: {
            trigger: 'item',
            position: (point, params, dom, rect, size) => {
              //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
              var x = point[0];//
              var y = point[1];
              var viewWidth = size.viewSize[0];
              var viewHeight = size.viewSize[1];
              var boxWidth = size.contentSize[0];
              var boxHeight = size.contentSize[1];
              var posX = 0;//x坐标位置
              var posY = 0;//y坐标位置

              if (x < boxWidth) {//左边放不开
                posX = 5;
              } else {//左边放的下
                posX = x - boxWidth;
              }

              if (y < boxHeight) {//上边放不开
                posY = 5;
              } else {//上边放得下
                posY = y - boxHeight;
              }

              return [posX, posY];

            },
            formatter: (x) => {
              if (x.data.source) {
                return null
              }
              const headerhtml = '<p style="margin: 0 auto; color:#ffffff;background-color:#999999;display:flex;align-items:center;">' + '<img style="height:24px;padding:0 10px;" src=' + imageUrl + x.data.name + ".png" + '>' + x.data.name + '</p>'
              let tablehtml = '<table style="color:rgba(0,0,0,0.6); border-collapse: collapse;">'
              for (const i of x.data.data) {
                tablehtml += '<tr style="border-bottom:1px solid #bbbbbb;"><td>' + i.label + '</td><td>' + i.value + '</td></tr>'
              }
              tablehtml += '</table>'
              return headerhtml + tablehtml
            },
            backgroundColor: 'rgba(0,0,0,0.2)'
          },
          series: [
            {
              layout: 'none',
              roam: false,
              lineStyle: {
                width: 0.5,
                curveness: 0,
                opacity: 0.7
              },
              itemStyle: {
                normal: {
                  color: '#6495ED'
                }
              },
              label: {
                normal: {
                  show: false
                }
              },
              emphasis: {
                focus: 'adjacency',
                label: {
                  position: 'right',
                  show: true
                }
              },
              symbolSize: 40,
              type: 'graph',
              edges: that.graphData.edges,
              data: nodes
            }
          ]
        }
        that.chart.setOption(option)
        that.chart.on('click', function(params) {
          if (params.data.id === 'China') {
            return
          } else {
            that.$router.push({ name: 'ChinaASEANInfoCountry', params: params })
          }
        })
      })
    },
    getImgData(imgSrc) {
      const fun = (resolve) => {
        const canvas = document.createElement('canvas')
        const contex = canvas.getContext('2d')
        const img = new Image()
        img.crossOrigin = ''

        img.onload = () => {
          const center = {
            x: img.width / 2,
            y: img.height / 2
          }
          const diameter = img.width
          canvas.width = diameter
          canvas.height = diameter
          contex.clearRect(0, 0, diameter, diameter)
          contex.save()
          contex.beginPath()
          const radius = img.height / 2
          contex.arc(radius, radius, radius, 0, 2 * Math.PI) // 画出圆
          contex.clip() // 裁剪上面的圆形
          contex.strokeStyle = '#999999'
          contex.lineWidth = 1
          contex.drawImage(img, center.x - radius + 1, center.y - radius + 1, diameter, diameter, 0, 0,
            diameter, diameter) // 在刚刚裁剪的园上画图
          contex.restore() // 还原状态
          resolve(canvas.toDataURL('image/png', 1))
        }
        img.src = imgSrc
      }
      const promise = new Promise(fun)
      return promise
    }
  }
}
</script>
<style scoped>
</style>
